import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { calendarIntegrationService } from '../pages/Calendars/services/calendarIntegration';
import { CalendarCreate } from '../pages/Calendars/types';

export const useCalendarIntegrations = () => {
  return useQuery({
    queryKey: ['calendar-integrations'],
    queryFn: () => calendarIntegrationService.list(),
  });
};

export const useCalendarIntegration = (id: string) => {
  return useQuery({
    queryKey: ['calendar-integrations', id],
    queryFn: () => calendarIntegrationService.get(id),
    enabled: !!id,
  });
};

export const useCreateCalendarIntegration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CalendarCreate) => calendarIntegrationService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-integrations'] });
    },
  });
};

export const useSyncCalendarEvents = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => calendarIntegrationService.syncEvents(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-integrations'] });
      queryClient.invalidateQueries({ queryKey: ['calendar-events'] });
    },
  });
};
